import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { DiscomfortSection } from '../components/DiscomfortSection';
import { AspirationSection } from '../components/AspirationSection';
import { WhatIsThisSection } from '../components/WhatIsThisSection';
import { MyStorySection } from '../components/MyStorySection';
import { MentorSection } from '../components/MentorSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ResultsSection } from '../components/ResultsSection';
import { IfYouveBeenSection } from '../components/IfYouveBeenSection';
import { IncludesSection } from '../components/IncludesSection';
import { ProgramSection } from '../components/ProgramSection';
import { PriceSection } from '../components/PriceSection';
import { FilterSection } from '../components/FilterSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { AudioPlayer } from '../components/AudioPlayer';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { TrustSection } from '../components/TrustSection';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
import { SocialProofToast } from '../components/SocialProofToast';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white selection:bg-[#C9A84C] selection:text-black" data-id="element-481">
      <AudioPlayer data-id="element-482" />
      <Navbar data-id="element-483" />
      <main data-id="element-484">
        <HeroSection data-id="element-485" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-486" />
        <DiscomfortSection data-id="element-487" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-488" />
        <AspirationSection data-id="element-489" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-490" />
        <WhatIsThisSection data-id="element-491" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-492" />
        <HowItWorksSection data-id="element-493" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-494" />
        <MyStorySection data-id="element-495" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-496" />
        <MentorSection data-id="element-497" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-498" />
        <ResultsSection data-id="element-499" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-500" />
        <IfYouveBeenSection data-id="element-501" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-502" />
        <IncludesSection data-id="element-503" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-504" />
        <ProgramSection data-id="element-505" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-506" />
        <TestimonialsSection data-id="element-507" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-508" />
        <PriceSection data-id="element-509" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-510" />
        <TrustSection data-id="element-511" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-512" />
        <FilterSection data-id="element-513" />
        <div className="h-px bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" data-id="element-514" />
        <FAQSection data-id="element-515" />
        <div className="h-px bg-gradient-to-r from-transparent via-white/5 to-transparent" data-id="element-516" />
        <FinalCTASection data-id="element-517" />
      </main>
      <StickyMobileCTA data-id="element-518" />
      <SocialProofToast data-id="element-519" />
      <footer className="py-10 bg-black border-t border-white/5" data-id="element-520">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-521">
          {/* Top row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8" data-id="element-522">
            <p className="font-['Bebas_Neue'] text-xl text-white tracking-widest" data-id="element-523">
              DOMINIO MENTAL
            </p>
            <div className="flex items-center gap-6 text-sm text-gray-500" data-id="element-524">
              <a href="mailto:dominiomentalok@gmail.com" className="hover:text-[#C9A84C] transition-colors flex items-center gap-1.5" data-id="element-525">
                <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4" data-id="element-526">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-527" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-528" />
                </svg>
                
              </a>
              <a href="https://instagram.com/dominiomentalok" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A84C] transition-colors flex items-center gap-1.5" data-id="element-529">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4" data-id="element-530">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-531" />
                </svg>
            
              </a>
            </div>
          </div>
        <div style={{
          marginTop: "12px",
          textAlign: "center"
        }} data-id="element-532">
  <a href="https://wa.me/5491166604113?text=Hola%2C%20tengo%20una%20duda%20sobre%20la%20mentor%C3%ADa%20por%20Zoom." target="_blank" style={{
            display: "inline-block",
            padding: "10px 18px",
            borderRadius: "999px",
            backgroundColor: "#25D366",
            color: "#000",
            fontWeight: "700",
            textDecoration: "none",
            fontSize: "14px"
          }} data-id="element-533">
    🟢 Tengo dudas, hablar por WhatsApp
  </a>
        </div>
          {/* Divider */}
          <div className="h-px bg-white/5 mb-6" data-id="element-534" />

          {/* Bottom row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-600" data-id="element-535">
            <p data-id="element-536">
              © {new Date().getFullYear()} DOMINIO MENTAL. Todos los derechos
              reservados.
            </p>
            <div className="flex items-center gap-4" data-id="element-537">
              <span className="hover:text-gray-400 transition-colors cursor-pointer" onClick={() => {
              const faq = document.querySelector('#precio');
              faq?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-538">
                Política de reembolso: 7 días sin preguntas
              </span>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}